import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { Helmet } from "react-helmet";
import {
  fetchCampaign,
  emailsList,
  emailsListNext,
  campaignsList,
  campaignsListNext,
  openModal,
} from "../../actions";
import Table from "../../components/Table";
import EmailListItem from "../../components/EmailListItem";
import CampaignListItem from "../../components/CampaignListItem";
import NonIdealState from "../../components/NonIdealState";
import Pin from "../../components/Pin";
import ViewCampaignToolbar from "./ViewCampaignToolbar";

const identity = (data) => data;

export class ViewCampaignPage extends Component {
  constructor(props) {
    super(props);
    this.renderEmail = this.renderEmail.bind(this);
    this.renderCampaign = this.renderCampaign.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteFolder = this.onDeleteFolder.bind(this);
    this.onClone = this.onClone.bind(this);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.onScroll = throttle(this.onScroll.bind(this), 300);

    this.fetchData = this.fetchData.bind(this);
    this.fetchMore = this.fetchMore.bind(this);

    this.state = {
      deleteOpen: true,
      emailName: "aadfs",
    };
  }

  componentWillMount() {
    this.fetchData(this.props.match.params);
    window.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.fetchData(nextProps.match.params);
    }
  }

  fetchData(params) {
    this.props.fetchCampaign(params.accountId, params.id).then((result) => {
      if (result?.data?.id) {
        this.props.campaignsList(
          this.props.match.params.accountId,
          {
            campaign: result.data.id,
          },
          params.id,
          true
        );
      }
    });
    this.props.emailsList(params.accountId, { campaignId: params.id }, true);
  }

  openCreateModal() {
    const { campaign } = this.props;
    const { accountId } = this.props.match.params;
    this.props.openModal("create-email", {
      accountId,
      campaignId: campaign.id,
    });
  }

  onDelete(emailId) {
    this.props.openModal("delete-email", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onDeleteFolder(campaignId) {
    this.props.openModal("delete-campaign", {
      id: campaignId,
      accountId: this.props.match.params.accountId,
    });
  }

  onClone(emailId) {
    this.props.openModal("clone-email", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onScroll(e) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight || document.body.clientHeight;
    if (scrollTop + window.innerHeight > scrollHeight - 50) {
      this.props.campaignsListNext(this.props.match.params.accountId);
      this.props.emailsListNext(this.props.match.params.accountId);
    }
  }

  fetchMore() {
    this.props.emailsListNext(this.props.match.params.accountId);
  }

  renderEmail(email) {
    return (
      <EmailListItem
        email={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderCampaign(campaign) {
    return (
      <CampaignListItem
        campaign={campaign}
        key={campaign.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDeleteFolder}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  render() {
    const { campaign, campaigns, emails, isFetching } = this.props;

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Emails`}</title>
        </Helmet>
        <Pin y={50}>
          <ViewCampaignToolbar
            accountId={this.props.match.params.accountId}
            campaign={campaign}
          />
        </Pin>
        {campaigns.length > 0 ? (
          <Table
            renderItem={this.renderCampaign}
            items={campaigns}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : undefined}
        {emails.length > 0 ? (
          <Table
            renderItem={this.renderEmail}
            items={emails}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : undefined}
        {campaigns.length === 0 && emails.length === 0 && !isFetching ? (
          <NonIdealState
            title="Campaign is empty"
            visual="file"
            action="Create Email"
            onAction={this.openCreateModal}
          />
        ) : undefined}
        {isFetching ? (
          <NonIdealState title="Loading" visual="refresh" spin />
        ) : undefined}
      </div>
    );
  }
}

ViewCampaignPage.propTypes = {
  emailsList: PropTypes.func.isRequired,
  emailsListNext: PropTypes.func.isRequired,
  emails: PropTypes.array.isRequired,
  openModal: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state, ownProps) {
  const emailsPagination = state.pagination.emails || {};
  const emails = (emailsPagination.ids || [])
    .map((id) => state.entities.email[id])
    .filter(identity);
  const campaign = state.entities.campaign[ownProps.match.params.id];

  const campaignsPagination =
    state.pagination.campaignsByParent[ownProps.match.params.id] || {};
  const campaigns = (campaignsPagination.ids || [])
    .map((id) => state.entities.campaign[id])
    .filter(identity);

  const isFetching =
    emailsPagination.isFetching || campaignsPagination.isFetching || false;

  return {
    campaign,
    campaigns,
    emails,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  fetchCampaign,
  emailsList,
  emailsListNext,
  campaignsList,
  campaignsListNext,
  openModal,
})(ViewCampaignPage);
